import { render, staticRenderFns } from "./InternalAgencyPageNew.vue?vue&type=template&id=678ba92c&scoped=true&"
import script from "./InternalAgencyPageNew.vue?vue&type=script&lang=js&"
export * from "./InternalAgencyPageNew.vue?vue&type=script&lang=js&"
import style0 from "./InternalAgencyPageNew.vue?vue&type=style&index=0&id=678ba92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678ba92c",
  null
  
)

export default component.exports